import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../../components/Layout/Layout';
import Modal from '../../../components/Modal/Modal';
import api from '../../../api/axios';

export default function CustomerList() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm] = useState({ name: '', adminName: '', adminEmail: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    fetchCustomers();
  }, []);

  async function fetchCustomers() {
    try {
      const res = await api.get('/customers');
      setCustomers(res.data);
    } finally {
      setLoading(false);
    }
  }

  async function handleCreate(e) {
    e.preventDefault();
    setSaving(true); setError('');
    try {
      await api.post('/customers', form);
      setSuccess('Kunde erfolgreich angelegt. Der Administrator erhält eine E-Mail mit seinen Zugangsdaten.');
      setModalOpen(false);
      setForm({ name: '', adminName: '', adminEmail: '' });
      fetchCustomers();
    } catch (err) {
      setError(err.response?.data?.message || 'Fehler beim Anlegen');
    } finally {
      setSaving(false);
    }
  }

  async function handleDelete(id, name) {
    if (!window.confirm(`Kunden "${name}" wirklich löschen? Alle Mitarbeiter und Daten werden entfernt.`)) return;
    try {
      await api.delete(`/customers/${id}`);
      setCustomers(prev => prev.filter(c => c.id !== id));
    } catch {
      alert('Fehler beim Löschen');
    }
  }

  return (
    <Layout title="Kunden">
      <div className="page-header">
        <div />
        <button className="btn btn-primary btn-sm" onClick={() => { setModalOpen(true); setError(''); setSuccess(''); }}>
          + Neuen Kunden anlegen
        </button>
      </div>

      {success && <div className="alert alert-success">{success}</div>}

      {loading ? <div>Laden...</div> : (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Mitarbeiter</th>
                <th>Schulungen</th>
                <th>Erstellt am</th>
                <th>Aktionen</th>
              </tr>
            </thead>
            <tbody>
              {customers.map(c => (
                <tr key={c.id}>
                  <td style={{ fontWeight: 600 }}>{c.name}</td>
                  <td>{c.employeeCount}</td>
                  <td>{c.trainingCount}</td>
                  <td>{new Date(c.created_at).toLocaleDateString('de-DE')}</td>
                  <td>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <Link to={`/admin/customers/${c.id}`} className="btn btn-ghost btn-sm">Details</Link>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDelete(c.id, c.name)}>Löschen</button>
                    </div>
                  </td>
                </tr>
              ))}
              {customers.length === 0 && (
                <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--gray-dark)' }}>Noch keine Kunden vorhanden</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} title="Neuen Kunden anlegen">
        <form onSubmit={handleCreate}>
          {error && <div className="alert alert-error">{error}</div>}
          <div className="form-group">
            <label>Unternehmensname</label>
            <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required placeholder="Muster GmbH" />
          </div>
          <div className="form-group">
            <label>Name des Administrators</label>
            <input value={form.adminName} onChange={e => setForm({ ...form, adminName: e.target.value })} required placeholder="Max Mustermann" />
          </div>
          <div className="form-group">
            <label>E-Mail des Administrators</label>
            <input type="email" value={form.adminEmail} onChange={e => setForm({ ...form, adminEmail: e.target.value })} required placeholder="admin@muster.de" />
          </div>
          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
            <button type="button" className="btn btn-ghost btn-sm" onClick={() => setModalOpen(false)}>Abbrechen</button>
            <button type="submit" className="btn btn-primary btn-sm" disabled={saving}>
              {saving ? 'Speichern...' : 'Anlegen'}
            </button>
          </div>
        </form>
      </Modal>
    </Layout>
  );
}
